"use client";

import { deleteCookie } from "cookies-next";
import React from "react";
import { cookieConsentName } from "./CookieConsent";
import { usePathname, useRouter } from "next/navigation";

const CookieSettingsLink: React.FC<{ asButton?: boolean }> = ({ asButton }) => {
  const pathname = usePathname();
  const router = useRouter();

  const removeCookieSettings = () => {
    if (pathname == "/cookies") {
      router.push("/");
      return;
    }

    deleteCookie(cookieConsentName);
    if (window) {
      window.location.reload();
    }
  };

  if (asButton)
    return (
      <button
        type="button"
        className="cursor-pointer text-left hover:underline"
        onClick={removeCookieSettings}
      >
        Cookie-indstillinger
      </button>
    );

  return (
    <div
      className="cursor-pointer hover:underline"
      onClick={removeCookieSettings}
    >
      Cookie-indstillinger
    </div>
  );
};

export default CookieSettingsLink;
